export default {
  SHAPE_TYPES: {
    SQUARE: "square",
    CIRCLE: "circle",
    VERTICAL_RECTANGLE: "verticalRectangle",
  },
};
